import React, { useState } from "react";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Button, Spinner } from "react-bootstrap";
import { parse, addHours, format } from "date-fns";
import { ConfirmModal } from "../../UI/components/ConfirmModal";

export function FoundFailedPaymentsTable(props) {

  const { auth } = useSelector(state => state);
  
  const { keycloakEnabledClientRoles } = auth;

  const hasReceiptAdmin = keycloakEnabledClientRoles.some(
    (role) => role.roleName === "RECEIPT_ADMIN" && role.isEnabled
  );

  //const date = Date().split(" ");
  //const dateStr = date[2] + date[1] + date[3];
  
  const dateFormater = (dateStr) => {
    // Parse as UTC
    const parsed = parse(dateStr, "yyyy-MM-dd HH:mm:ss", new Date());
    // Add +10 hours
    const localDate = addHours(parsed, 10);

    //Format
    return format(localDate, "yyyy-MM-dd HH:mm:ss");

  };

  const moneyFormater = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "PGK"
  });
  
  //const presentDate = new Date();
  //const formatPresentDate = format(presentDate, "dd/MM/yyyy");
  
  
  
  const columns = [
    {
      name: "CId",
      selector: (row) => row?.customerId,
      sortable: false,
      width:"70px"
    },
    {
      name: "PId",
      selector: (row) => row?.paymentId,
      sortable: false,
      width:"70px"
    },
    {
      name: "First Name",
      selector: (row) => row?.customerFirstName,
      sortable: false,
      width:"120px"

    },
    {
      name: "Last Name",
      selector: (row) => row?.customerLastName,
      sortable: false,
      width:"120px"

    },
    {
      name: "Phone",
      selector: (row) => row?.customerMobileNumber,
      sortable: false,
      width:"140px"

    },
    {
      name: "Email",
      selector: (row) => row?.customerEmail,
      sortable: false,
      width:"280px"

    },
    {
      name: "Status",
      selector: (row) => row?.paymentStatus,
      sortable: false,
      width:"90px"

    },
    {
      name: "Datetime",
      selector: (row) => row?.paymentDate? dateFormater(row.paymentDate) : null,
      sortable: false,      
      width:"180px"

    },
    {
      name: "Item",
      selector: (row) => row?.serviceItem,
      sortable: false,
    },
    {
      name: "Amount",
      selector: (row) => moneyFormater.format(row?.paymentAmount),
      sortable: false,
      width:"130px"

    },
    {
      name: "Prov",
      selector: (row) => row?.province,
      sortable: false,
      width:"90px"
    },
    {
      name: "Agency",
      selector: (row) => row?.department,
      sortable: false,
      width:"90px"

    },
    {
      name: 'Actions',
      cell: row => (
        <>
          {hasReceiptAdmin && <Button size="sm" onClick={() => {handleGenerateReceipt(row)}} variant="outline-danger">Generate</Button>}
        </>
      ),
      width:"130px"

    },
  
   
  ];

  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedPaymentSearch, setSelectedPaymentSearch] = useState(null);


  const handleYes = () => {
    setShowConfirm(false);
    props.onGenerateReceipt(selectedPaymentSearch)
  };

  const handleNo = () => {
    setShowConfirm(false);
  };

  const handleGenerateReceipt = (ps) => {
    setSelectedPaymentSearch(ps);
    setShowConfirm(true);
  }
  
  const dataTableStyles = {
    rows: {
      style: {
        fontSize: "15px"
      },
    },
    headCells: {
      style: {
        fontSize: "16px"
      },
    },
    cells: {
      style: {
        fontSize: "15px"
      },
    },
    pagination: {
      style: {
        fontSize: "16px"
      }
    }
  };
  



  return (

    <div className="card card-custom card-stretch gutter-b">

      {/* begin::Header */}

      {/* end::Header */}

      {/* begin::Body */}

      
      <div className="card-body py-6">
        <div className="row">
          <div className="col-12">
            <DataTable
              key={JSON.stringify(props.data)}
              title="Failed Payments Search"
              customStyles={dataTableStyles}
              columns={columns}
              data={props.data}
              progressComponent={<Spinner variant="primary" animation="border" />}
            />
            {/* end::Table */}
          </div>
        </div>
      </div>
      <ConfirmModal
        show={showConfirm}
        question={`This will update the payment status to successful for failed Payment Id (PId) ${selectedPaymentSearch?.paymentId} and generate an Online E-Receipt for Customer ${selectedPaymentSearch?.customerFirstName} ${selectedPaymentSearch?.customerLastName}. Are you sure you want to continue?`}
        onYes={handleYes}
        onNo={handleNo}
      />
      {/* end::Body */}
    </div>
  );
}
